<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/build' }">党建专栏</el-breadcrumb-item>
        <el-breadcrumb-item>党建详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>拧紧“过紧日子”的制度螺栓</h2>
        <p style="text-align: right">
          <span style="margin-right: 60px">2025-05-28</span>
        </p>
        <p>
          近日，中共中央、国务院印发了修订后的《党政机关厉行节约反对浪费条例》（以下简称《条例》）。这是时隔近12年之后，党中央对这一重要条例进行修订，与时俱进完善多项规定，进一步拧紧党政机关带头过紧日子的制度螺栓。特别是在“总则”中，《条例》新增“应当深入贯彻中央八项规定精神”最新表述，以制度机制固化作风建设成果，这对深入贯彻中央八项规定精神、持续深化纠治“四风”具有重要意义。
        </p>
        <p>
          历览前贤国与家，成由勤俭败由奢。艰苦奋斗、勤俭节约是中华民族的传统美德，也是我们党的政治本色和优良传统。回顾党的百余年奋斗历程，从毛泽东同志强调“务必使同志们继续地保持艰苦奋斗的作风”，到习近平总书记提出“坚持不懈纠正‘四风’”，我们党始终将艰苦奋斗、勤俭节约作为党的优良作风并发扬光大，不断赋予其新的时代内涵。
        </p>
        <p>
          党的十八大以来，以习近平同志为核心的党中央从制定出台中央八项规定开局破题，从治理“天价月饼”等“小切口”入手，刹住了一些曾被认为不可能刹住的奢靡之风，攻克了一些顽瘴痼疾。
        </p>
        <p>
          以好作风护航新征程，全党从思想根源上着力，从内心深处树立尚俭戒奢、艰苦朴素、勤俭节约的意识和行为准则，使尚俭戒奢的良好风尚成为全党全社会的共同追求。如今，领导干部到基层调研，轻车简从，不铺张、不浪费，已成为一种自觉；“天价粽子”“天价月饼”不见了，这些节气食物重回亲民路线；聚会适度消费，提倡“光盘行动”，崇廉尚俭的社会风尚正在形成。
        </p>
        <p>
          新风新貌扑面而来，成为艰苦奋斗、勤俭节约思想深入人心，融入工作与生活的生动写照。“八项规定改变中国”成为广大人民群众的心声，党在新时代的徙木立信之举赢得了党心民心，中央八项规定成为新时代党的作风建设的“金色名片”。
        </p>
        <p>
          克勤于邦，克俭于家。勤俭节约是传统美德，反对浪费是社会共识。习近平总书记指出：“不论我们国家发展到什么水平，不论人民生活改善到什么地步，艰苦奋斗、勤俭节约的思想永远不能丢。”党政机关是全社会行为和道德风尚的标杆，传递的是行为准则，影响的是社会风气。领导干部是党和国家事业发展的“关键少数”，对全党全社会具有风向标作用，是人民群众观察党风政风的重要窗口，其一言一行都具有示范性和放大效应。中央八项规定之所以成为“金色名片”，核心就在于抓好“关键少数”、带动“绝大多数”，“关键少数”发挥了关键作用。党政机关和领导干部应切实带好头做表率，树立正确政绩观，认真学习宣传贯彻《条例》，自觉同“小事小节论”“影响发展论”“行业特殊论”等错误思想作斗争，压缩奢靡之风隐形变异的空间，以身作则、以上率下，不断增强本地区本部门严格落实《条例》的政治自觉、思想自觉、行动自觉，构筑抵御歪风邪气的铜墙铁壁，始终做到不放纵、不越轨、不逾矩，持续以优良党风政风带动社风民风向上向善。
        </p>
        <p>
          厉行勤俭节约是中央八项规定的重要内容，需要久久为功。《条例》坚持目标导向和问题导向相结合，针对强化“四风”纠治特别是深化整治铺张浪费现象，进一步落实责任，严明纪律要求，让制度长牙带刺，显示了党中央对在新时代继续发扬艰苦奋斗、勤俭节约优良作风重大意义的清醒认识和坚定决心。党政机关和领导干部应以开展深入贯彻中央八项规定精神学习教育为重要抓手，对照《条例》深入查摆问题，用钉钉子精神抓落实。尤其需要紧盯各种隐形变异的铺张浪费和奢靡享乐现象，主动接受群众和社会监督，坚持奢靡之风与腐败问题同查同治，坚决斩断由风及腐的链条，做到立查立改、即知即改；向制度要动力，以学习宣传贯彻《条例》为契机，进一步完善相关法律法规和政策措施，强化制度执行，真正让铁规发力、禁令生威。
        </p>
        <p>
          风成于上，俗化于下。节俭朴素，力戒奢靡，是事关“修身”“兴业”的大事。学习宣传贯彻《条例》，更要筑牢勤俭节约、反对浪费的意识，在做好每一件小事中见成效，在履行每一项职责中见精神。要教育和引导广大党员干部从我做起、从小事做起，坚持以俭修身、以俭兴业，自觉做“过紧日子”的践行者、示范者、宣传者、推动者。从一餐饭、一瓶水、一度电、一张纸做起，争做勤俭节约的标杆，从坚持到习惯，从他律到自为，真正把“过紧日子”作为践行为民初心的“试金石”，在全社会进一步营造浪费可耻、节约光荣的浓厚氛围。
        </p>
        <p>（作者：陈银健，系江南大学纪检监察研究院研究员）</p>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span style="cursor: pointer; color: #666; font-size: 14px">
            &nbsp;&nbsp;&nbsp;&nbsp;
            <!-- &lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;又踏层峰辟新天——《中共中央关于进一步全面深化改革、推进中国式现代化的决定》... -->
          </span>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build11' })"
            >中办印发《通知》在全党开展深入贯彻中...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span
          >
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.kongxi {
  height: 10px;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }

  .blue01 {
    font-weight: bold;
    color: #000080;
  }
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}
</style>
